import React from "react";
import styled from "styled-components";

const TAG_VARIANTS = {
  success: {
    backgroundColor: "var(--green)",
    color: "var(--white)",
  },
  warning: {
    backgroundColor: "#f0ad4e",
    color: "var(--white)",
  },
  error: {
    backgroundColor: "#c1232c",
    color: "var(--white)",
  },
  info: {
    backgroundColor: "#467fcf",
    color: "var(--white)",
  },
  required: {
    backgroundColor: "#c1232c",
    color: "var(--white)",
  },
};
    const TagContent = styled('span', {
      shouldForwardProp: (prop) => !['color'].includes(prop),
    })`
     
      text-box-trim: trim-both;
      text-transform: uppercase;
      font-family: "Segoe UI";
      font-size: 11px;
      text-align: center;
      margin: 0;
      font-weight: bold;
      line-height: 1;
      color: ${props => props.color};
    `;

    const TagWrapper = styled('div', {
      shouldForwardProp: (prop) => !['color', 'backgroundColor'].includes(prop),
    })`
      display: inline-flex;
      align-items: center;
      align-content: center;
      flex-direction: row;
      justify-content: center;
      padding: 3px 5px;
      height: 17px;
      min-width: fit-content;
      width: fit-content;
      border-radius: 2px;
      overflow: hidden;
      margin: 0;
      white-space: nowrap;
      background-color: ${props => props.backgroundColor};
      color: ${props => props.color};
    `;


function Tag({ children, variant = "success", text, style = {} }) {
  const variantStyles = TAG_VARIANTS[variant] || TAG_VARIANTS.success;
  const displayText = text || children;

  return (
    <TagWrapper 
      backgroundColor={variantStyles.backgroundColor}
      color={variantStyles.color}
      style={style}
    >
      <TagContent color={variantStyles.color}>
      {displayText}
      </TagContent>
      
    </TagWrapper>
  );
}

export default Tag;

